import React from 'react';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import {
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Button,
  Switch,
  FormControlLabel
} from '@mui/material';

import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  changePasswordButton: {
    margin: '10px 0'
  }
});

const Maintenance = props => {
  const { onChange, title, message, severity, enabled } = props;

  const classes = useClasses(styles);

  const isEnabled = (enabled === true)
  
  return (
    <React.Fragment>
      <CardHeader
        title='Maintenance Mode'
      />
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            size={{xs:12, md:12}}
          >
            <FormControlLabel
              control={<Switch checked={isEnabled} onChange={(event) => onChange(event, 'maintenance')} name="enabled" color="primary" />}
              label="Maintenance Mode Enabled"
            />
          </Grid>
        </Grid>
      </CardContent>
    </React.Fragment>
  );
};

export default withErrorHandler(Maintenance, axios)